// extracted by mini-css-extract-plugin
export default {"image-toggle":"image-toggle___kPRWP"};